"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRatesAreas = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateRatesArea_1 = require("./StateRatesArea");
class StateRatesAreas extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Rates areas", true);
        this._includeDeleted = false;
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateRatesArea_1.StateRatesArea);
        this._setupFilters();
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
            this.page.ctrls.btnNew.hide();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const areas = yield this.lockgui(this.app.api.admin.directory.getAllRateAreas(this._includeDeleted));
            if (!areas)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(areas);
            return _super.start.call(this);
        });
    }
    fill(areas) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = "";
            for (const area of areas) {
                const item = new com.ListItem();
                item.ctrls.lType.text = area.isDeleted
                    ? "Rates area (deleted)"
                    : "Rates area";
                item.ctrls.lId.text = `#${area.id}`;
                let data = [gs.text.clearHtmlToText(`${area.name}`)];
                item.ctrls.pData.html = data.join("<br>");
                this.page.ctrls.list.append(item);
                item.onclick = () => gs_1.StateGS.Run(StateRatesArea_1.StateRatesArea, area);
            }
        });
    }
    _setupFilters() {
        this.page.ctrls.blockFilters.show();
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "Show";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Active only", "active"));
        select.append(new Option("All areas", "all"));
        select.value = this._includeDeleted ? "all" : "active";
        select.onchange = () => __awaiter(this, void 0, void 0, function* () {
            this._includeDeleted = select.value === "all";
            const areas = yield this.lockgui(this.app.api.admin.directory.getAllRateAreas(this._includeDeleted));
            if (areas)
                yield this.fill(areas);
        });
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        return element instanceof HTMLSelectElement ? element : null;
    }
}
exports.StateRatesAreas = StateRatesAreas;
StateRatesAreas.StateName = "ratesAreas";
//# sourceMappingURL=StateRatesAreas.js.map